export const SHOW_STICKTOSTER = 'SHOW_STICKTOSTER';
export const HIDE_STICYTOSTER = 'HIDE_STICYTOSTER';
export const UPDATE_STICKYTOSTER_DATA='UPDATE_STICKYTOSTER_DATA'
export const showStickyToster = ()=>(dispatch) => { 
    dispatch({
        type: SHOW_STICKTOSTER,
        payload: {showMessage: true}
      });
};
export const hideStickyToster = () => ({
    type: HIDE_STICYTOSTER,
    payload: {
        showMessage:false
    }
})
export const updateStickyToster = (message,icon,color,textcolor) => ({
    type: UPDATE_STICKYTOSTER_DATA,
    payload: {
        message:message,
        icon:icon,
        color:color,
        textcolor:textcolor
    }
})


